import React from "react";
import logo from "../assets/ohhfit-logo-small.png";

function HomePage() {
    return (
        <div className="jumbotron">
            <img src={logo} alt="OhhFit" />
            <h1>Ohh!! Fit</h1>
            <h2>One Hit huMan Fit</h2>
            <h3>OHM... Fit</h3>
        </div>
    );
}

export default HomePage;
